import { useState } from "react";
import { Modal } from "antd";
import VenueMap from "components/venue-map/VenueMap";
import { Venue } from "interfaces/venue";
import "./VenueMap.scss";

interface VenueSelectionModalProps {
  isOpen: boolean;
  onClose: (selectedVenues: Venue[]) => void;
  venues?: Venue[];
  initialSelected?: Venue[];
}

const VenueSelectionModal: React.FC<VenueSelectionModalProps> = ({
  isOpen,
  onClose,
  venues = [],
  initialSelected = [],
}) => {
  const [selectedVenues, setSelectedVenues] =
    useState<Venue[]>(initialSelected);

  // const handleVenueClick = (venue: Venue) => {
  //   setSelectedVenues((prev) =>
  //     prev.some((v) => v.uuid === venue.uuid)
  //       ? prev.filter((v) => v.uuid !== venue.uuid)
  //       : [...prev, venue]
  //   );
  // };

  const handleOk = () => {
    onClose(selectedVenues);
  };

  const handleCancel = () => {
    onClose(initialSelected);
  };

  return (
    <Modal
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      title="Select locations to add to your campaign"
      width={900}
      className="venue-selection-modal"
      okText="Add Selected"
      cancelText="Cancel"
      destroyOnClose
    >
      <div className="venue-selection-modal__map-section">
        <VenueMap
          venues={venues}
          selectedVenueUuids={selectedVenues.map((v) => v.uuid)}
          onSelectionChange={(ids: string[]) => {
            setSelectedVenues(
              venues.filter((venue) => ids.includes(venue.uuid))
            );
          }}
        />
      </div>

      <div className="venue-selection-modal__selected-section">
        <div className="venue-selection-modal__selected-header">
          <span className="venue-selection-modal__selected-title">
            Selected Locations ({selectedVenues.length})
          </span>
          <span className="venue-selection-modal__selected-subtitle">
            Select a location for your campaign
          </span>
        </div>
        {selectedVenues.length === 0 ? (
          <div className="venue-selection-modal__none">No venues selected.</div>
        ) : (
          <div className="venue-selection-modal__selected-list">
            {selectedVenues.map((venue) => (
              <div
                key={venue.uuid}
                className="venue-selection-modal__selected-item"
              >
                <span className="venue-selection-modal__selected-name">
                  {venue.name}
                </span>
                <span className="venue-selection-modal__selected-address">
                  {venue.addressDisplay || venue.address}
                </span>
                {/* <button
                  className="venue-selection-modal__remove-btn"
                  onClick={() => handleVenueClick(venue)}
                  aria-label={`Remove ${venue.name}`}
                >
                  &times;
                </button> */}
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default VenueSelectionModal;
